<section class="reels-section pt-100 pb-70">
  <div class="container">
    <div class="section-title text-center">
      <div class="title-badge">SHOP BY REELS</div>
      <h2 class="section-heading">Transform Your Space with Inspiration</h2>
      <p class="section-subheading">
        Discover how our tiles and sanitaryware solutions can elevate your home design
      </p>
    </div>

    <div class="reels-slider position-relative">
      <!-- Left Arrow Button -->
      <button class="carousel-arrow left" (click)="testimonialCarousel?.prev()">←</button>

      <!-- Right Arrow Button -->
      <button class="carousel-arrow right" (click)="testimonialCarousel?.next()">→</button>

      <owl-carousel-o #testimonialCarousel [options]="videoSliderOptions">
        <ng-template carouselSlide *ngFor="let video of videoSlides">
          <div class="reel-item">
            <div class="reel-thumbnail-wrapper" (click)="openVideo(video.id)">
              <img
                [src]="getThumbnailUrl(video.id)"
                alt="Design Inspiration Reel"
                class="reel-thumbnail"
              />
              <div class="play-overlay">
                <i class="bx bx-play"></i>
              </div>
              <div class="reel-overlay">
                <div class="reel-content">
                  <h4>Design Inspiration</h4>
                  <p>Transform your space</p>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>
</section>

<!-- Video Modal Overlay -->
<div *ngIf="activeVideoId" class="video-modal-overlay" (click)="closeVideo()">
  <div class="video-modal" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="closeVideo()">×</button>
    <iframe
      [src]="safeVideoUrl"
      frameborder="0"
      allowfullscreen
      allow="autoplay; encrypted-media">
    </iframe>
  </div>
</div>